import type { TOC } from '@ember/component/template-only';
import { PrismIconFlag } from '@mylighthouse/prism-ember';

interface HotelMarketInsightListsListItemsListItemHolidaySignature {
  Args: {
    event: unknown;
  };
}

const HotelMarketInsightListsListItemsListItemHoliday = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class="flex flex-col">
    <p class="event-name text-300--bold">
      {{@event.name}}
    </p>
    <div class="mt-200 flex flex-row gap-200">
      {{#each @event.countries as |country|}}
        <PrismIconFlag @code={{country}} />
      {{/each}}
    </div>
  </div>
</template> satisfies TOC<HotelMarketInsightListsListItemsListItemHolidaySignature>;

export default HotelMarketInsightListsListItemsListItemHoliday;
